import { Component, OnDestroy, OnInit } from "@angular/core";
import { ItemPreguntaDTO, PreguntaDTO } from "@DTOS";
import { ItemPreguntaModelDTO, PreguntaModelDTO } from "@Models";
import { CommandAsync, ICommand } from "@nahuelmorata/ngx-command";
import { Store } from "@ngxs/store";
import { ModalAccionesItemComponent } from "@shared/components/modal-acciones-item/modal-acciones-item.component";
import { PreguntasTipoEnum, obtenerIdPreguntaTipo } from "@shared/enums";
import { ModalService, NotificacionServiceEmisor } from "@shared/services";
import { Nilable } from "@shared/utils";
import { filter, debounceTime, mergeMap, tap, Subscription, map } from "rxjs";
import { EncuestasService } from "src/app/layout/encuestas/encuestas.service";
import { TiposPreguntasService } from "../../tipos-preguntas.service";
import { TipoPreguntaBreakpointComponent } from "../tipo-pregunta-breakpoint/tipo-pregunta-breakpoint.component";

@Component({
    selector: "app-tipo-pregunta-seleccion-imagenes",
    templateUrl: "./tipo-pregunta-seleccion-imagenes.component.html",
    styleUrls: ["./tipo-pregunta-seleccion-imagenes.component.scss"]
})
export class TipoPreguntaSeleccionImagenesComponent extends TipoPreguntaBreakpointComponent
    implements OnInit, OnDestroy {
    protected pregunta: PreguntaModelDTO = new PreguntaModelDTO(new PreguntaDTO());
    protected items: ItemPreguntaModelDTO[] = [];
    protected colores = {};
    protected textoItem = "";

    protected agregarCmd: ICommand = new CommandAsync(() => this.agregarItem());
    protected borrarCmd: ICommand = new CommandAsync((item: ItemPreguntaModelDTO) => this.borrarItem(item));
    protected abrirAccionesCmd: ICommand = new CommandAsync((item: ItemPreguntaModelDTO) =>
        this.abrirAccionesItem(item));

    private subsItems = new Subscription();
    private subsAcciones: Nilable<Subscription>;

    constructor(private tiposPreguntasService: TiposPreguntasService, store: Store,
        private notificacionService: NotificacionServiceEmisor, private modalService: ModalService,
        private encuestasService: EncuestasService) {
        super(store);
    }

    ngOnInit(): void {
        if (this.tiposPreguntasService.preguntaModel != null) {
            this.pregunta = this.tiposPreguntasService.preguntaModel;
        }
        this.colores = this.tiposPreguntasService.colores;

        this.cargarItemsModels();
    }

    ngOnDestroy() {
        this.subsItems.unsubscribe();
        this.subsAcciones?.unsubscribe();
    }

    protected obtenerId(tipoPregunta: PreguntasTipoEnum) {
        return obtenerIdPreguntaTipo(tipoPregunta);
    }

    private async agregarItem(): Promise<void> {
        let itemPreguntaDTO = new ItemPreguntaDTO({
            text: this.textoItem.trim()
        });

        this.textoItem = "";
        itemPreguntaDTO = await this.tiposPreguntasService.agregarItemPregunta(this.pregunta.Entidad, itemPreguntaDTO);
        const model = this.crearItemModel(itemPreguntaDTO);
        this.items.push(model);
        this.notificacionService.notificarExito("Item agregado correctamente.");
    }

    private async borrarItem(item: ItemPreguntaModelDTO): Promise<void> {
        await this.tiposPreguntasService.borrarItemPregunta(this.pregunta.Entidad, item.Entidad);
        this.subsItems.unsubscribe();
        this.subsItems = new Subscription();
        this.cargarItemsModels();
        this.notificacionService.notificarExito("Item borrado correctamente.");
    }

    private cargarItemsModels() {
        this.items = this.pregunta?.Items.map(item => this.crearItemModel(item)) ?? [];
    }

    private crearItemModel(item: ItemPreguntaDTO) {
        const model = new ItemPreguntaModelDTO(item);
        this.subsItems.add(
            model.changed$.pipe(
                filter(Boolean),
                filter(() => item.texto !== ""),
                debounceTime(400),
                mergeMap(() => this.tiposPreguntasService.guardarItemPregunta(this.pregunta.Entidad, item)),
                tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
            ).subscribe()
        );
        return model;
    }

    private async abrirAccionesItem(item: ItemPreguntaModelDTO) {
        const modalRef = this.modalService.open(ModalAccionesItemComponent, { centered: true });
        const instancia: ModalAccionesItemComponent = modalRef.componentInstance;
        await instancia.cargarItem(item);
        this.subsAcciones = new Subscription();
        this.subsAcciones.add(
            instancia.guardarAccionItem$.pipe(
                mergeMap(accion => this.encuestasService.agregarAccionItem(
                    this.tiposPreguntasService.encuesta, this.pregunta.Entidad, item.Entidad, accion
                ))
            ).subscribe(async accion => {
                item.Acciones.push(accion);
                instancia.acciones = [...item.Acciones];
            })
        );
        this.subsAcciones.add(
            instancia.borrarAccionItem$.pipe(
                mergeMap(accion => this.encuestasService.borrarAccionItem(
                    this.tiposPreguntasService.encuesta, this.pregunta.Entidad, item.Entidad, accion
                ).pipe(
                    map(() => accion)
                ))
            ).subscribe(accionBorrar => {
                item.Entidad.acciones = item.Acciones.filter(accion => accion.id !== accionBorrar.id);
                instancia.acciones = [...item.Acciones];

            })
        );
        await modalRef.result.catch(() => null);
        this.subsAcciones.unsubscribe();
        this.subsAcciones = null;
    }
}
